<template>
<section class="dashboard">
	<div class="section-dashboard-headbar">
		<div class="container mt-3 mb-3">
			<erco-dashboard-headbar></erco-dashboard-headbar>
		</div>
	</div>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 mt-3 mb-3">
					<erco-statusbar></erco-statusbar>
				</div>
			</div>
		</div>
	</div>

	<div class="bg-faded">
		<div class="container">
			<div class="row pt-3 mb-3">
				<div class="col-12">
						<erco-editbar></erco-editbar>
				</div>
			</div>

			<div class="freshly-copied-items-container" v-if="freshlyCopiedItems.length > 0">
				<b class="d-block mt-4 mb-4">Geklonte / leer kopierte Objekte</b>
				<erco-object-card-overview :items="freshlyCopiedItems"
				                           :disabledItemRestriction="true">
				</erco-object-card-overview>
				<hr />
			</div>

			<erco-object-card-overview :items="notFreshlyCopiedItems"
			                           :visibleItemsNum="visibleItemsNum"
			                           :disabledItemRestriction="disabledItemRestriction">
			</erco-object-card-overview>
			<b-alert class="info"
					 v-if="!loading"
			         :show="filteredItems.length === 0">
				<span v-if="!itemFiltersActive">Keine Objekte gefunden!</span>
				<span v-if="itemFiltersActive">Keine Objekte unter Berücksichtigung der aktiven Filter gefunden!</span>
				<div v-if="searchString.length > 0" class="mt-4"><strong>Hinweis:</strong> Die Suche ist aktiv</div>
			</b-alert>
			<div class="item-fetcher_">
				<b-button class="_button"
				          v-if="!disabledItemRestriction && moreItemsAvailable"
				          @click="handleItemFetch">
					Mehr Einträge anzeigen
				</b-button>
			</div>
		</div>
		<erco-cloak class="cloak"
	            v-if="inProcess">
		</erco-cloak>
	</div>
</section>

</template>

<script>
	import ErcoDashboardHeadbar from '@/components/organisms/ErcoDashboardHeadbar';
	import ErcoEditbar from '@/components/organisms/ErcoEditbar';
	import ErcoStatusbar from '@/components/molecules/ErcoStatusbar';
	import ErcoObjectCardOverview from '@/components/organisms/ErcoObjectCardOverview';
	import ErcoCloak from '@/components/molecules/ErcoCloak';
	import Fuse from 'fuse.js';

	const searchOptions = {
		shouldSort: true,
		threshold: 0,
		location: 0,
		distance: 0,
		minMatchCharLength: 1,
		tokenize: true,
		matchAllTokens: true,
		keys: [
			'S_de_Objekt',
			'S_Bereich',
			'S_Gattung',
			'S_Spezifikation',
			'PKM_Objekt',
			'S_Zusatz',
			'PKM_PDB',
			'FKM_PKM_PDB',
		],
	};

	export default {
		name: 'ErcoDashboardPage',
		data() {
			return {
				visibleItemsNum: 12,
				visibleItemsNumStep: 12,
			};
		},
		created() {
			[
				this.$store.dispatch('initDashboard'),
				this.$store.dispatch('getCMSStructure'),
				this.$store.dispatch('getStatiList'),
			].forEach((dispatchAction) => {
				dispatchAction.then(() => {
					this.resetAccessErrorStatusCode();
				})
				.catch(() => {
					/* TODO: Use (better) logging; Keine Verbindung zur Ressource:', response */
				});
			});
		},
		mounted() {
			document.title = 'Dashboard - Light Scout Publisher';
		},

		computed: {
			token() {
				return this.$store.state.user.token;
			},
			loading() {
				return this.$store.state.dashboard.loadingObjectData;
			},
			inProcess() {
				const actionInProcess = this.$store.state.dashboard.actionInProcess;

				return this.loading || actionInProcess;
			},
			itemFilters() {
				return this.$store.state.dashboard.activeFilters;
			},
			itemFiltersActive() {
				return Object.keys(this.itemFilters).length > 0;
			},
			searchString() {
				return this.$store.state.dashboard.searchString.trim();
			},
			filteredItems() {
				let filteredItems = this.items;

				if (!filteredItems) {
					return [];
				}

				Object.keys(this.itemFilters).forEach((key) => {
					const filter = this.itemFilters[key];
					filteredItems = filteredItems.filter(filter.filterFunc);
				});

				filteredItems = filteredItems.filter(item =>
					item.FKM_Status !== this.$store.getters.statiAssoc.gelöscht);

				if (this.searchString === '') {
					return filteredItems;
				}

				const fuse = new Fuse(filteredItems, searchOptions);
				return fuse.search(this.searchString);
			},
			notFreshlyCopiedItems() {
				return this.filteredItems.filter(item => !item.isFreshlyCopied);
			},
			freshlyCopiedItems() {
				return this.filteredItems.filter(item => item.isFreshlyCopied);
			},
			items() {
				return this.$store.state.dashboard.objectData;
			},
			disabledItemRestriction() {
				const searchString = this.$store.state.dashboard.searchString.trim();
				return !(searchString === '');
			},
			moreItemsAvailable() {
				return this.filteredItems.length > this.visibleItemsNum;
			},
		},
		methods: {
			handleItemFetch() {
				this.visibleItemsNum += this.visibleItemsNumStep;
			},
			resetAccessErrorStatusCode() {
				this.$store.dispatch('setAccessErrorStatusCode', -1);
			},
		},
		watch: {
		},
		components: {
			ErcoDashboardHeadbar,
			ErcoEditbar,
			ErcoStatusbar,
			ErcoObjectCardOverview,
			ErcoCloak,
		},
	};
</script>

<style lang="scss">
	@import '~bootstrap/scss/_variables.scss';

	.dashboard {
		& > .section-dashboard-headbar {
			$border-color: darken($body-bg, 3%);
			border-bottom: 1px solid $border-color;
		}

		& > .bg-faded {
			min-height: 100vh;
			position: relative;
		}

		& .container {
			& > .info {
				margin-top: 4rem;
			}

			& > .item-fetcher_ {
				text-align: center;
				padding: 4rem 0;
				width: 100%;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoDashboard.vue?5bbf04be